import React from "react";

const STEPS = [
    "Wallet signal",
    "Consent request",
    "Clinician / pharmacist review",
    "Safe exchange / coach support",
    "KATLAS receipt",
];

export const JourneyStrip = ({ active = 0 }) => (
    <section
        className="bg-[var(--paper-alt)] border-b hairline"
        data-testid="journey-strip"
    >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-10 overflow-x-auto">
            <p className="mono-label mb-6">The governed journey</p>
            <ol className="flex items-center gap-3 sm:gap-6 min-w-max">
                {STEPS.map((step, i) => {
                    const isActive = i <= active;
                    return (
                        <li key={step} className="flex items-center gap-3 sm:gap-6">
                            <div className="flex items-center gap-3">
                                <span
                                    className="inline-flex items-center justify-center h-7 w-7 border border-[var(--ink)] font-mono"
                                    style={{
                                        fontSize: 11,
                                        background: isActive
                                            ? "var(--ink)"
                                            : "transparent",
                                        color: isActive ? "#fff" : "var(--ink)",
                                    }}
                                >
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span
                                    className="font-serif whitespace-nowrap"
                                    style={{
                                        fontSize: 15,
                                        color: isActive
                                            ? "var(--ink)"
                                            : "var(--ink-muted)",
                                    }}
                                >
                                    {step}
                                </span>
                            </div>
                            {i < STEPS.length - 1 && (
                                <span
                                    aria-hidden
                                    className="hidden sm:inline-block"
                                    style={{
                                        width: 56,
                                        height: 1,
                                        background: "var(--rule)",
                                    }}
                                />
                            )}
                        </li>
                    );
                })}
            </ol>
        </div>
    </section>
);

export default JourneyStrip;
